import React, { useEffect, useState, useRef } from 'react';
import Popover from '../../../components/Popover/Popover';
import Button from '../../../components/Button/Button';
import { t } from '../../../i18n';
import s from '../WatchtowerPage.module.scss';
import { useSearchParams } from 'next/navigation';
import { useFlowmap } from '../FlowmapContext';
import { useFilters } from '../FiltersContext';
import Icon from '../../../components/Icon';
import Checkbox from '../../../components/Checkbox/Checkbox';

const LayerPicker = ({ map, _handleFlowmapToggle }) => {
    const { showFlowmap, setShowFlowmap, flowmapData } = useFlowmap();
    const { setIsFiltersShown } = useFilters();
    const searchParams = useSearchParams();
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const popoverRef = useRef(null);

    const toggleFilterDropdown = () => {
        setIsFilterDropdownOpen(!isFilterDropdownOpen);
    };

    const handleFlowmapToggle = (e) => {
        const checked = e.target.checked;
        setShowFlowmap(checked);

        const params = new URLSearchParams(searchParams.toString());
        if (checked) {
            params.set('flowmap', 'true');
            params.delete('fromCountries');
            params.delete('toCountries');
            sessionStorage.setItem('showFlowmap', 'true');
            setIsFiltersShown(true);
        } else {
            params.delete('flowmap');
            sessionStorage.removeItem('showFlowmap');
            setIsFiltersShown(false);
        }

        const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
        window.history.replaceState({}, '', newUrl);

        _handleFlowmapToggle(checked);
        setIsFilterDropdownOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popoverRef.current &&
                !popoverRef.current.contains(event.target)
            ) {
                setIsFilterDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [popoverRef]);

    useEffect(() => {
        if (showFlowmap) {
            const params = new URLSearchParams(window.location.search);
            params.set('flowmap', 'true');
            window.history.replaceState(
                {},
                '',
                `${window.location.pathname}?${params.toString()}`
            );
            sessionStorage.setItem('showFlowmap', 'true');
            setIsFiltersShown(true);
            setShowFlowmap(true);
        }
    }, [showFlowmap, setIsFiltersShown]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const flowmapParam = params.get('flowmap');
        const hasFlowmapInUrl = flowmapParam === 'true';

        if (hasFlowmapInUrl) {
            setShowFlowmap(true);
            setIsFiltersShown(true);
            sessionStorage.setItem('showFlowmap', 'true');
        }
    }, []);

    return (
        <div className={s.LayerPicker} ref={popoverRef}>
            <Popover
                isPopoverOpen={isFilterDropdownOpen}
                minWidth="233px"
                modifier=""
                onClick={toggleFilterDropdown}
                overrideButton={
                    <div className={s.Filter}>
                        <Button
                            title={t('watchtowerPage.layers')}
                            modifier="FilterAlternative"
                            className={s.FilterButton}
                            size="Small"
                            icon="Stacks"
                            isActive={isFilterDropdownOpen}
                            description={showFlowmap ? `(1)` : null}
                        />
                    </div>
                }
                content={
                    <div className={s.PopoverContent}>
                        <div className={s.LayerOption}>
                            <label
                                className={s.LayerLabel}
                                htmlFor="toggle-flowmap-layer"
                                style={{ cursor: 'pointer' }}>
                                <div className={s.LayerIcon}>
                                    <Icon name="FlowmapBlue" />
                                </div>
                                {t('watchtowerPage.showFlowmapLayer')}
                            </label>
                            <Checkbox
                                modifier="Alternative"
                                value="flowmap"
                                checked={showFlowmap}
                                onChange={handleFlowmapToggle}
                            />
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default LayerPicker;
